export const ADD_C_LOADING = 'ADD_C_LOADING'
export const ADD_C_ERROR = 'ADD_C_ERROR'
export const ADD_C_SUCCESS = 'ADD_C_SUCCESS'
export const UPDATE_LOADING = 'UPDATE_LOADING'
export const UPDATE_ERROR = 'UPDATE_ERROR'
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS'
export const DELETE_COLLECTION = 'DELETE_COLLECTION'
export const CLEAR_NOTIF_STATE = 'CLEAR_NOTIF_STATE'
